<ng-container *ngIf="!editing(); else editForm">
  <app-button
    type="button"
    backgroundColor="var(--blue-500)"
    text="Cadastrar serviço"
    icon="pi-plus"
    textAlign="flex-start"
    [fullWidth]="false"
    (click)="newService()"
  ></app-button>
  <div *ngIf="isLoadingServices()" class="loading-container">
    <div class="loading-spinner"></div>
    <p>Carregando serviços...</p>
  </div>
  
  <ng-container *ngIf="!isLoadingServices() && services().length; else empty">
    <div class="services" *ngFor="let service of services()">
      <app-service-card
        [service]="service"
        (edit)="startEditing(service)"
        (remove)="deleteService(service.id)"
        (toggleAtivo)="setAtivo(service, $event)"
      ></app-service-card>
    </div>
    <div class="pagination" *ngIf="totalPages() > 1">
      <p-paginator
        (onPageChange)="onPageChange($event)"
        [first]="(currentPage() - 1) * 6"
        [rows]="6"
        [totalRecords]="totalItems()"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} serviços"
      ></p-paginator>
    </div>
  </ng-container>
</ng-container>

<ng-template #empty>
  <div class="empty" *ngIf="!isLoadingServices()">
    <span>
      <i class="pi pi-exclamation-triangle"></i>
      Nenhum serviço cadastrado
    </span>
  </div>
</ng-template>

<ng-template #editForm>
  <div class="buttons">
    <app-button
      type="button"
      backgroundColor="var(--slate-500)"
      text="Voltar"
      icon="pi-arrow-left"
      textAlign="flex-start"
      [fullWidth]="false"
      (click)="close()"
    ></app-button>
    <app-button
      type="button"
      backgroundColor="var(--orange-500)"
      text="Descartar alterações"
      icon="pi-trash"
      textAlign="flex-start"
      [fullWidth]="false"
      (click)="discardChanges()"
    ></app-button>
  </div>
  <app-service-form
    [servico]="toEdit()"
    [isLoading]="isLoading()"
    [submitText]="buttonText()"
    [submitIcon]="buttonIcon()"
    (save)="submit($event)"
  ></app-service-form>
</ng-template>
